const parseTlv = (payload) => {
  const fields = [];
  let cursor = 0;

  while (cursor < payload.length) {
    if (cursor + 4 > payload.length) {
      throw new Error("Struktur payload QRIS tidak lengkap.");
    }

    const id = payload.slice(cursor, cursor + 2);
    const lengthText = payload.slice(cursor + 2, cursor + 4);
    const length = Number(lengthText);

    if (!/^\d{2}$/.test(id) || !/^\d{2}$/.test(lengthText)) {
      throw new Error("Tag atau panjang payload QRIS tidak valid.");
    }

    const valueStart = cursor + 4;
    const valueEnd = valueStart + length;
    if (valueEnd > payload.length) {
      throw new Error(`Isi tag QRIS ${id} terpotong.`);
    }

    fields.push({ id, value: payload.slice(valueStart, valueEnd) });
    cursor = valueEnd;
  }

  return fields;
};

const encodeField = ({ id, value }) => {
  const text = String(value);
  if (text.length > 99) {
    throw new Error(`Isi tag QRIS ${id} terlalu panjang.`);
  }

  return `${id}${String(text.length).padStart(2, "0")}${text}`;
};

export const crc16Ccitt = (value) => {
  let crc = 0xffff;

  for (let index = 0; index < value.length; index += 1) {
    crc ^= value.charCodeAt(index) << 8;
    for (let bit = 0; bit < 8; bit += 1) {
      crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
    }
  }

  return crc.toString(16).toUpperCase().padStart(4, "0");
};

export const validateQrisPayload = (payload) => {
  const normalized = String(payload || "").trim();
  if (!normalized) {
    throw new Error("Payload QRIS belum tersedia.");
  }

  const fields = parseTlv(normalized);
  const crcField = fields[fields.length - 1];

  if (fields[0]?.id !== "00" || fields[0]?.value !== "01") {
    throw new Error("Payload bukan EMV QR versi yang didukung.");
  }
  if (fields.find((field) => field.id === "53")?.value !== "360" || fields.find((field) => field.id === "58")?.value !== "ID") {
    throw new Error("Kode QR bukan QRIS Indonesia.");
  }
  if (crcField?.id !== "63" || crcField.value.length !== 4 || !normalized.endsWith(`6304${crcField.value}`)) {
    throw new Error("Checksum QRIS tidak ditemukan.");
  }

  const expectedCrc = crc16Ccitt(normalized.slice(0, -4));
  if (expectedCrc !== crcField.value.toUpperCase()) {
    throw new Error("Checksum QRIS tidak valid.");
  }

  return fields;
};

export const getQrisMerchantName = (payload, fallback = "Merchant QRIS") => {
  try {
    return validateQrisPayload(payload).find((field) => field.id === "59")?.value?.trim() || fallback;
  } catch (_error) {
    return fallback;
  }
};

export const createDynamicQrisPayload = (staticPayload, total) => {
  const amount = Math.round(Number(total));
  if (!Number.isFinite(amount) || amount <= 0) {
    throw new Error("Nominal pembayaran QRIS harus lebih dari Rp0.");
  }

  const sourceFields = validateQrisPayload(staticPayload);
  const fields = [];
  let hasInitiationMethod = false;
  let hasAmount = false;

  sourceFields.forEach((field) => {
    if (field.id === "63" || field.id === "54") {
      return;
    }

    if (field.id === "01") {
      fields.push({ id: "01", value: "12" });
      hasInitiationMethod = true;
      return;
    }

    fields.push(field);
    if (field.id === "53") {
      fields.push({ id: "54", value: String(amount) });
      hasAmount = true;
    }
  });

  if (!hasInitiationMethod) {
    fields.splice(1, 0, { id: "01", value: "12" });
  }
  if (!hasAmount) {
    const countryIndex = fields.findIndex((field) => field.id === "58");
    fields.splice(countryIndex >= 0 ? countryIndex : fields.length, 0, { id: "54", value: String(amount) });
  }

  const withoutCrc = `${fields.map(encodeField).join("")}6304`;
  return `${withoutCrc}${crc16Ccitt(withoutCrc)}`;
};
